export const GRID_VIEW = {
    PRODUCT_MENU: {
        MANAGE_DELIVERIES: "manage-deliveries",
        VIEW_INVENTORY: "view-inventory",
        DUPLICATE: "duplicate",
        REMOVE_PRODUCT: "remove-product",
    },
    DETAILS_MENU: {
        COPY_QTY: "copy-quantities",
        PASTE_QTY: "paste-quantities",
        PASTE_QTY_BY_SIZE: "paste-quantities-by-size",
        PASTE_QTY_TO_SIZES: "paste-quantities-to-sizes",
        ENABLE_ALL_LOCATIONS: "enable-all-location-combined",
        ENABLE_BY_LOCATION: "enable-by-location",
        EDIT_DELIVERY: "edit-delivery",
        REMOVE_DELIVERY: "remove-delivery",
        GROUP_BY_DELIVERY: "group-by-delivery",
    },
    LOCATIONS_MENU: {
        ENABLE_ALL_LOCATIONS: "enable-all-locations",
        ENABLE_BY_LOCATION: "enable-by-location",
        DUPLICATE_QUANTITIES: "duplicate-quantities",
        DUPLICATE_QUANTITIES_IN_GROUP: "duplicate-quantities-in-group",
    },
    MORE_MENU: {
        MENU_BUTTON: "menu-button",
    },
};
